module.exports = __webpack_public_path__ + "img/sc.427b0ad9.png";